import { render, staticRenderFns } from "./planEdit.vue?vue&type=template&id=83d4a3e4"
import script from "./planEdit.vue?vue&type=script&lang=js"
export * from "./planEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports